export var MessageStartEventData;
(function (MessageStartEventData) {
    /**
     * Role of message sender.
     */
    let role;
    (function (role) {
        role["ASSISTANT"] = "assistant";
        role["USER"] = "user";
    })(role = MessageStartEventData.role || (MessageStartEventData.role = {}));
})(MessageStartEventData || (MessageStartEventData = {}));
